export default "__VITE_ASSET__CiTYyQRq__"